export default {
	en: {
		translation: {
			getty: {
				no_auth_title: "Upload assets from your Getty Images account.",
				no_auth_action: "Connect to Getty Images",
				no_auth_statement:
					"Find the perfect royalty-free image for your next project from the world's best photo library of creative stock photos, vector art illustrations and stock.",
				reg_link_text: "Click here to create a Getty Images account",
				select: "Select",
				search: {
					placeholder: "Search...",
					reset: "Reset search",
				},
				media_types: {
					images: "Images",
					videos: "Videos",
				},
				media_types_singular: {
					images: "image",
					videos: "video",
				},
				popular_categories: "Popular categories",
				diversity_categories: "Diversity categories",
				filters: {
					toggle_filters_button: "Filters",
					clear: "Clear",
					available_for_creative_images:
						"Filter is available only for creative images",
					available_for_creative_videos:
						"Filter is available only for creative videos",
					available_for_creative_editorial_videos:
						"Filter is available only for creative or editorial images",
					sort_options: {
						label: "Sort by",
						newest: "Newest",
						best_match: "Best match",
						most_popular: "Most popular",
						random: "Random",
					},
					orientation: {
						label: "Orientation",
						horizontal: "Horizontal",
						vertical: "Vertical",
						square: "Square",
						panoramic_horizontal: "Panoramic horizontal",
						panoramic_vertical: "Panoramic vertical",
					},
					number_of_people: {
						label: "Number of People",
						none: "None",
						one: "One",
						two: "Two",
						group: "Group",
					},
					license: {
						label: "License Type",
						creative: "Creative",
						editorial: "Editorial",
						all: "All"
					},
					license_model: {
						label: "License model",
						rightsready: "Rights-ready",
						royaltyfree: "Royality-free",
						all: "RF and RR"
					},
					colors: {
						label: "Colors",
					},
					age_of_people: {
						label: "Age",
						baby: "Baby",
						child: "Child",
						teenager: "Teenager",
						young_adult: "Young adult",
						adult: "Adult",
						adults_only: "Adults only",
						mature_adult: "Mature adult",
						senior_adult: "Senior adult"
					},
					ethnicity: {
						label: "Ethnicity",
						black: "Black",
						caucasian: "Caucasian",
						east_asian: "East Asian",
						hispanic_latino: "Hispanic/LatinX",
						middle_eastern: "Middle Eastern",
						mixed_race_person: "Mixed Race Person",
						multiethnic_group: "Multi-Ethnic gGroup",
						native_american_first_nations: "Native American/First Nations",
						pacific_islander: "Pacific Islander",
						south_asian: "South Asian",
						southeast_asian: "Southeast Asian"
					},
					resolution: {
						label: "Resolution",
					},
					duration: {
						label: "Duration",
					},
					more: {
						label: "More",
						safe: "Safe (Exclude nudity)",
						exclude_editorial_use_only: "Exclude 'Editorial use only'",
						embed_content_only: "Embeddable images"
					},
					minimumSize: {
						label: "Image resolution",
						large: "12 MP and larger",
						x_large: "16 MP and larger",
						xx_large: "21 MP and larger"
					},
					compositions: {
						label: "Image style",
						abstract: "Abstract",
						portrait: "Portrait",
						close_up: "Close-up",
						sparse: "Sparse",
						cut_out: "Cut out",
						full_frame: "Full frame",
						copy_space: "Copy space",
						macro: "Macro",
						still_life: "Still life",
					},
					videoCompositions: {
						label: "Composition",
						close_up: "Close-up",
						candid: "Candid",
						looking_at_camera: "Looking at camera"
					},
					frameRates: {
						label: "Frame Rate",
					},
					viewpoint: {
						label: "Viewpoint",
						lockdown: "Lockdown",
						panning: "Panning",
						tracking_shot: "Tracking shot",
						aerial_view: "Aerial view",
						high_angle_view: "High angle view",
						low_angle_view: "Low angle view",
						tilt: "Tilt",
						point_of_view: "Point of view",
					},
					imageTechniques: {
						label: "Image Technique",
						realtime: "Realtime",
						time_lapse: "Time lapse",
						slow_motion: "Slow motion",
						color: "Color",
						black_and_white: "Black and white",
						animation: "Animation",
						selective_focus: "Selective focus",
					},
					summary: {
						label: "Filters",
						color: "color: {{color}}",
						number_of_people: {
							none: "Without people",
							one: "With one person",
							two: "With two people",
							group: "With group people",
						},
						license_type: {
							all: "All types",
							creative: "Creative",
							editorial: "Editorial"
						},
						orientations: {
							square: "Square",
							vertical: "Vertical",
							horizontal: "Horizontal",
							panoramic_horizontal: "Panoramic horizontal",
							panoramic_vertical: "Panoramic vertical",
						},
						minimum_size: {
							large: "12 MP and larger",
							x_large: "16 MP and larger",
							xx_large: "21 MP and larger"
						},
						compositions: {
							abstract: "Abstract",
							portrait: "Portrait",
							close_up: "Close-up",
							sparse: "Sparse",
							cut_out: "Cut out",
							full_frame: "Full frame",
							copy_space: "Copy space",
							macro: "Macro",
							still_life: "Still life",
						},
						image_techniques: {
							realtime: "Realtime",
							time_lapse: "Time lapse",
							slow_motion: "Slow motion",
							color: "Color",
							black_and_white: "Black and white",
							animation: "Animation",
							selective_focus: "Selective focus",
						},
						viewpoints: {
							lockdown: "Lockdown",
							panning: "Panning",
							tracking_shot: "Tracking shot",
							aerial_view: "Aerial view",
							high_angle_view: "High angle view",
							low_angle_view: "Low angle view",
							tilt: "Tilt",
							point_of_view: "Point of view",
						},
						video_compositions: {
							close_up: "Close-up",
							candid: "Candid",
							looking_at_camera: "Looking at camera"
						},
						license_models: {
							rightsready: "Rights-ready",
							royaltyfree: "Royality-free",
							all: "RF and RR"
						},
						exclude_nudity: "Safe (Exclude nudity)",
						exclude_editorial_use_only: "Exclude 'Editorial use only'",
						embed_content_only: "Embeddable images"
					}
				},
				purchase: {
					select_plan: "Select Plan",
					select_format: "Select Format & Size",
					manage_plans: "Manage Plans",
					format: "Select Format & Size",
					credit: "Credit",
					credits: "Credits",
					plan_exceeded: "Plan Exceeded",
					size: {
						x_small: "X Small",
						small: "Small",
						medium: "Medium",
						large: "Large",
						x_large: "X Large",
						xx_large: "XX Large",
						vector: "Vector"
					},
					credits_remaining: "credits remainings",
					media_type_not_included: "Your current plan does not include this {{mediaType}}",
					images: "images",
					videos: "videos",
					days_left: "days left",
					credits_balance_too_small: "Your credits balance is too small",
					collection: "Collection",
					item_id: "Creative #",
					license_type: "License type",
					release_info: "Release info",
					location: "Location",
					description: "Description",
					rightsmanaged: "Rights-Managed/Rights-Ready",
					royaltyfree: "Royalty-Free",
					cost: "Cost"
				},
				buttons: {
					next: "Next",
					upload: "Upload",
					purchase: "Acquire",
				}
			},
		},
	},
};
